export enum HeaderTypeEnum {
  AUTHORIZATION = 'Authorization',
  JWT_TOKEN = 'Jwt-Access-Token',
  JWT_REFRESH_TOKEN = 'Jwt-Refresh-Token'
}
